import React, { Component } from 'react';
import { Row, Col, Collapse, CardBody, Card, CardHeader } from 'reactstrap';

class NuestraEmpresa extends Component {
  constructor(props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.state = {
      activeIndex: 0,
      collapse: 0
    };
  }

  handleToggle(e) {
    const event = e.target.dataset.event;
    this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
  }

  render() {
    const { info } = this.props;
    const { collapse } = this.state;
    let list = [];
    list.push({
      title: info.title,
      description: info.description,
      image: info.image,
    });
    if (info.subpages && info.subpages.length > 0) {
      info.subpages.map((subpage) => {
        list.push({
          title: subpage.title,
          description: subpage.description,
          image: subpage.image
        })
      });
    }
    return (
      <section>

        <Row className="justify-content-center">
          <Col xs="12">

            {list && list.length && list.map((card, index) => {
              return (
                <Card className="mb-3 acordeon-custom-item cast" key={index}>
                  <CardHeader
                    onClick={this.handleToggle}
                    data-event={index}
                    className={`text-left ${collapse === index ? 'active' : ''}`}
                  >
                    <span className="d-inline-block mr-3">{index + 1}</span>{card.title}
                  </CardHeader>
                  <Collapse isOpen={collapse === index}>
                    <CardBody>
                      <Row className='align-items-center'>
                        <Col lg={7}>
                          <div className="richtext-content" dangerouslySetInnerHTML={{ __html: card.description }} />
                        </Col>
                        <Col lg={5}>
                          <figure class="ratio-2-1">
                            <img src={card.image} className="d-block w-100" />
                          </figure>
                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </Card>
              );
            })}
          </Col>
        </Row>
      </section>
    );
  }
}

export default NuestraEmpresa;
